(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[922],{

/***/ 4461:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/[slug]",
      function () {
        return __webpack_require__(2401);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ AUTHOR_CHIP_FRAGMENT; },
/* harmony export */   "Z": function() { return /* binding */ AuthorChip; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2086);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8224);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9813);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9203);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4918);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3236);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AuthorChip on Author {\n    name\n    slug\n    picture {\n      url(\n        transformation: {\n          image: { resize: { fit: crop, width: 100, height: 100 } }\n        }\n      )\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var AUTHOR_CHIP_FRAGMENT = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_templateObject());
function AuthorChip(param) {
    var author = param.author;
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/author/".concat(author.slug),
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            avatar: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                alt: author.name,
                src: (ref = author.picture) === null || ref === void 0 ? void 0 : ref.url
            }),
            clickable: true,
            label: author.name
        })
    });
};


/***/ }),

/***/ 4358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2086);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5303);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3236);



function Container(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: children
    });
};


/***/ }),

/***/ 8471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2086);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2645);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4918);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3236);




function Header() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/",
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            variant: "h1",
            children: "Yet another SWE Blog."
        })
    });
};


/***/ }),

/***/ 1792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2086);
// EXTERNAL MODULE: ./components/container.tsx
var container = __webpack_require__(4358);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.8.2_5c3a54a43c7b18819b71f8b7f88a45f7/node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(2645);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.8.2_5c3a54a43c7b18819b71f8b7f88a45f7/node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(218);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.6_f27a4c237496d6873c96491b66a1e77e/node_modules/next/link.js
var next_link = __webpack_require__(4918);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(3236);
;// CONCATENATED MODULE: ./components/footer.tsx





function Footer() {
    var link = /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "https://github.com/Neitsch/neitsch.github.io",
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            underline: "always",
            children: "here"
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                children: [
                    "Built with NextJS. Find the source ",
                    link,
                    "."
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.6_f27a4c237496d6873c96491b66a1e77e/node_modules/next/head.js
var head = __webpack_require__(2726);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.6_f27a4c237496d6873c96491b66a1e77e/node_modules/next/router.js
var next_router = __webpack_require__(2455);
;// CONCATENATED MODULE: ./components/meta.tsx





var site = "https://www.nigel-schuster.de";
function Meta() {
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        var handleRouteChange = function(url) {
            window.goatcounter.count({
                path: url
            });
        };
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            router.events.off("routeChangeStart", handleRouteChange);
        };
    }, [
        router.events
    ]);
    var canonicalURL = site + (0,next_router.useRouter)().asPath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: canonicalURL,
                rel: "canonical"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: "/favicon/apple-touch-icon.png",
                sizes: "180x180"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: "/favicon/favicon-32x32.png",
                rel: "icon",
                sizes: "32x32",
                type: "image/png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: "/favicon/favicon-16x16.png",
                rel: "icon",
                sizes: "16x16",
                type: "image/png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: "/favicon/site.webmanifest",
                rel: "manifest"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                color: "#000000",
                href: "/favicon/safari-pinned-tab.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: "/favicon/favicon.ico",
                rel: "icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: "#000000",
                name: "msapplication-TileColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: "/favicon/browserconfig.xml",
                name: "msapplication-config"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: "#000",
                name: "theme-color"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: "/feed.xml",
                rel: "alternate",
                type: "application/rss+xml"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: "Personal blog.",
                name: "description"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                async: true,
                "data-goatcounter": "https://nigel.goatcounter.com/count",
                "data-goatcounter-settings": "{}",
                src: "//gc.zgo.at/count.js"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/layout.tsx




function Layout(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "min-h-screen",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    children: children
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
        ]
    });
};


/***/ }),

/***/ 768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ MORE_STORIES; },
/* harmony export */   "Z": function() { return /* binding */ MoreStories; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2086);
/* harmony import */ var _components_post_preview__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4926);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(218);
/* harmony import */ var _mui_lab_Masonry__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6380);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9203);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3236);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  fragment MoreStories on Query {\n    moreStories: posts(\n      orderBy: date_DESC\n      first: 2\n      where: { slug_not_in: [$slug] }\n    ) {\n      ...PostPreview\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var MORE_STORIES = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_templateObject(), _components_post_preview__WEBPACK_IMPORTED_MODULE_1__/* .POST_PREVIEW_FRAGMENT */ .H);
function MoreStories(param) {
    var moreStories = param.moreStories;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                variant: "h4",
                children: "More Stories"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_lab_Masonry__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                columns: {
                    xs: 1,
                    sm: 2
                },
                spacing: {
                    xs: 1,
                    sm: 1,
                    md: 2
                },
                children: moreStories.map(function(post) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_post_preview__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            post: post
                        })
                    }, post.slug);
                })
            })
        ]
    });
};


/***/ }),

/***/ 4926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ POST_PREVIEW_FRAGMENT; },
/* harmony export */   "Z": function() { return /* binding */ PostPreview; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2086);
/* harmony import */ var _author_chip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(970);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7563);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(218);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2645);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2299);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6696);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2754);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8062);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9203);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4918);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3236);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  fragment PostPreview on Post {\n    title\n    slug\n    excerpt\n    coverImage {\n      url(\n        transformation: {\n          image: { resize: { fit: crop, width: 2000, height: 1000 } }\n        }\n      )\n    }\n    author {\n      ...AuthorChip\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var POST_PREVIEW_FRAGMENT = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_templateObject(), _author_chip__WEBPACK_IMPORTED_MODULE_1__/* .AUTHOR_CHIP_FRAGMENT */ .R);
function PostPreview(param) {
    var _post = param.post, title = _post.title, coverImage = _post.coverImage, excerpt = _post.excerpt, author = _post.author, slug = _post.slug;
    var titleElem = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        flexGrow: 1,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            variant: "h4",
            children: title
        })
    });
    var previewHeader = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        display: "flex",
        children: [
            titleElem,
            author ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                alignSelf: "flex-end",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_author_chip__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    author: author
                })
            }) : null
        ]
    });
    var excerptElem = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        variant: "body1",
        children: excerpt
    });
    var innerCardContent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            previewHeader,
            excerptElem
        ]
    });
    var cardContent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/posts/".concat(slug),
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            children: innerCardContent
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                component: "img",
                src: coverImage === null || coverImage === void 0 ? void 0 : coverImage.url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    children: cardContent
                })
            })
        ]
    });
};


/***/ }),

/***/ 3407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SectionSeparator; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2086);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3236);


function SectionSeparator() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
        className: "border-accent-2 mt-28 mb-24"
    });
};


/***/ }),

/***/ 2401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "POST_FRAGMENT": function() { return /* binding */ POST_FRAGMENT; },
/* harmony export */   "POST_LOOKUP": function() { return /* binding */ POST_LOOKUP; },
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Post; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2086);
/* harmony import */ var _components_author_chip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(970);
/* harmony import */ var _components_container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4358);
/* harmony import */ var _components_header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8471);
/* harmony import */ var _components_layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1792);
/* harmony import */ var _components_more_stories__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(768);
/* harmony import */ var _components_section_separator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3407);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7563);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(218);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2299);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6696);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2754);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(8200);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9203);
/* harmony import */ var highlight_js_lib_languages_x86asm__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(4494);
/* harmony import */ var highlight_js_styles_default_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7670);
/* harmony import */ var highlight_js_styles_default_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(highlight_js_styles_default_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2726);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(6503);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(20);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(4385);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(9941);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(2507);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(6042);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(189);
/* harmony import */ var rehype_highlight__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(2616);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  fragment Post on Post {\n    title\n    excerpt\n    slug\n    content\n    date\n    ogImage: coverImage {\n      url(\n        transformation: {\n          image: { resize: { fit: crop, width: 2000, height: 1000 } }\n        }\n      )\n    }\n    coverImage {\n      url(\n        transformation: {\n          image: { resize: { fit: crop, width: 2000, height: 1000 } }\n        }\n      )\n    }\n    author {\n      ...AuthorChip\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  fragment PostLookup on Query {\n    post(stage: $stage, where: { slug: $slug }) {\n      ...Post\n    }\n    ...MoreStories\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}















var __N_SSG = true;
var POST_FRAGMENT = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_templateObject(), _components_author_chip__WEBPACK_IMPORTED_MODULE_1__/* .AUTHOR_CHIP_FRAGMENT */ .R);
var POST_LOOKUP = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_templateObject1(), _components_more_stories__WEBPACK_IMPORTED_MODULE_5__/* .MORE_STORIES */ .E);
function Post(param) {
    var post = param.post, moreStories = param.moreStories;
    var content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        children: "Something went wrong"
    });
    if (post) {
        var ref;
        var _excerpt, _excerpt1;
        var head = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_8___default()), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: post.title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    content: (_excerpt = post.excerpt) !== null && _excerpt !== void 0 ? _excerpt : "",
                    name: "description"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    content: post.title,
                    property: "og:title"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    content: (_excerpt1 = post.excerpt) !== null && _excerpt1 !== void 0 ? _excerpt1 : "",
                    property: "og:description"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    content: "article",
                    property: "og:type"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    content: "en_US",
                    property: "og:locale"
                })
            ]
        });
        var titleElem = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            flexGrow: 1,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                component: "h1",
                variant: "h3",
                children: post.title
            })
        });
        var authorElem = post.author ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            alignSelf: "flex-end",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_author_chip__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                author: post.author
            })
        }) : null;
        var body = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    component: "img",
                    src: (ref = post.coverImage) === null || ref === void 0 ? void 0 : ref.url
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            display: "flex",
                            children: [
                                titleElem,
                                authorElem
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_15__/* .ReactMarkdown */ .D, {
                            rehypePlugins: [
                                [
                                    rehype_highlight__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z,
                                    {
                                        languages: {
                                            x86asm: highlight_js_lib_languages_x86asm__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z
                                        }
                                    }
                                ], 
                            ],
                            children: post.content
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            sx: {
                                fontStyle: "italic",
                                paddingBottom: "1.5em"
                            },
                            children: [
                                "Published on ",
                                post.date,
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            children:  true && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                        url: window.location.href,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                            round: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                        url: window.location.href,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                            round: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                        url: window.location.href,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                            round: true
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
        content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                head,
                body
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_header__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        content,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_section_separator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_more_stories__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            moreStories: moreStories
                        })
                    ]
                })
            ]
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [503,721,826,774,888,179], function() { return __webpack_exec__(4461); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);